/**
 * The initial value of Symbol.iterator is the well-known symbol @@iterator
 * https://tc39.es/ecma262/#sec-symbol.iterator
 */
export const symbolIterator = () => Symbol("Symbol.iterator");
